import modular from 'modujs';
import * as modules from './modules';
import globals from './globals';
import { html } from './utils/dom';
import { CSS_CLASS } from './config';

const PRELOADER_TIMEOUT = 2200;

const app = new modular({
  modules: modules,
});

window.addEventListener('DOMContentLoaded', (event) => {
  html.classList.add('is-dom-ready');
});

window.addEventListener('load', (event) => {
  const stylesId = 'app-css';
  const styles = document.getElementById(stylesId);

  if (styles) {
    if (styles.isLoaded) {
      init();
    } else {
      styles.addEventListener('load', (event) => init());
    }
  } else {
    console.warn('The #app-css stylesheet not found');
  }
});

function init() {
  globals();

  app.init(app);

  html.classList.add(CSS_CLASS.LOADED);
  html.classList.add(CSS_CLASS.READY);
  html.classList.remove(CSS_CLASS.LOADING);
}
